<template>
  <div v-if="total > 0">
    <div id="wenzhang-list" class="wenzhang-list">
    <div class="left-right-content reverse clearfix">
      <div class="c-left">
        <div
          class="column-dav-theme clearfix"
          v-for="(item, index) in showData"
          :key="index"
        >
          <router-link
            :to="{ path: '/column/themedetail', query: { id: item.id,plate:item.belongSection } }"
            target="_blank"
            class="img-f"
          >
            <img :src="item.thumbnail" alt="" />
          </router-link>
          <div class="infoes">
            <div class="tit">
              <router-link
                :to="{ path: '/column/themedetail', query: { id: item.id ,plate:item.belongSection} }"
                target="_blank"
                >{{ item.archiveTitle }}</router-link
              >
            </div>
            <div class="user-info clearfix">
              <router-link
                :to="{ path: '/home', query: { userId: item.creatorId } }"
                class="user-avatar"
              >
                <img :src="item.imgUrl" alt="" />
              </router-link>
              <router-link
                :to="{ path: '/home', query: { userId: item.creatorId } }"
                class="user-name over-e"
                >{{ item.creatorName }}</router-link
              >
              <span class="qianm over-e" :title="item.signature">{{
                item.signature
              }}</span>
            </div>
            <div class="desc">{{ item.archiveDescription }}</div>
            <div class="btn-cz clearfix">
              <i class="icon see"></i
              ><span class="much">{{ item.viewCount }}</span>
              <i class="icon zan"></i
              ><span class="much">{{ item.likeCount }}</span>
              <i class="icon cai"></i
              ><span class="much">{{ item.dislikeCount }}</span>
              <i class="icon share"></i
              ><span class="much">{{ item.shareCount }}</span>
              <span class="date">{{ item.createTime | formatTime }}</span>
            </div>
          </div>
        </div>

        <div class="pagintion-f">
          <el-pagination
            background
            @current-change="search"
            layout="prev, pager, next"
            :current-page="queryParam.pageIndex"
            :page-size="queryParam.pageSize"
            :total="total"
            :hide-on-single-page="true"
          >
          </el-pagination>
        </div>
      </div>
      <div class="c-right">
        <div class="one-item">
          <div class="detail-userinfo">
            <router-link
              :to="{ path: '/home', query: { userId: userInfo.userId } }"
              class="avatar-f"
              ><img :src="userInfo.imgUrl" alt=""
            /></router-link>
            <div class="user-name">
              <router-link
                :to="{ path: '/home', query: { userId: userInfo.userId } }"
                >{{ userInfo.userName }}</router-link
              >
            </div>
            <div class="chenghao">{{ userInfo.signature }}</div>
            <div class="qianming">{{ userInfo.introduction }}</div>
            <div class="btns" v-if="isLogin && userInfo.userId != loginUserId">
              <el-button
                class="btn wgz-btn"
                v-if="userInfo.followStatus == 0"
                @click="doFollow(userInfo.userId)"
                ><i class="el-icon-plus"></i> 关注</el-button
              >
              <el-button
                class="btn"
                v-else-if="userInfo.followStatus == 1"
                @click="undoFollower(userInfo.userId)"
                >已关注</el-button
              >
              <el-button
                class="btn"
                v-else-if="userInfo.followStatus == 2"
                @click="undoFollower(userInfo.userId)"
                >互相关注</el-button
              >

              <el-button
                class="btn wgz-btn"
                v-if="friendStatus == 4"
                @click="addFriend()"
                ><i class="el-icon-plus"></i> 加好友</el-button
              >
              <el-button class="btn" v-else-if="friendStatus == 2"
                >发消息</el-button
              >
              <el-button
                class="btn"
                v-else-if="friendStatus == 1"
                style="cursor:auto"
                >请求中</el-button
              >
            </div>
            <ul class="much-list three clearfix">
              <li>
                <span class="tit">文章</span>
                <span class="count">{{ total }}</span>
              </li>
              <li>
                <span class="tit">阅读</span>
                <span class="count">{{ userInfo.viewCount }}</span>
              </li>
              <li>
                <span class="tit">被赞</span>
                <span class="count">{{ userInfo.likeCount }}</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
  </div>

  <div class="common-no-data" v-else>
    <img class="img" :src="require('@/assets/images/empty_img.png')" alt="" />
    <span class="words">抱歉！您访问的页面暂无数据</span>
  </div>

</template>

<script type="text/ecmascript-6">
  import archiveApi from '@/api/archive'
  import userInfoApi from '@/api/userInfo'
  // import Pagination from '@/components/Pagination'
  import homeApi from '@/api/home'

  import { mapState } from "vuex";
  import updateTdk from "@/utils/tdk";

export default {
  components: {
    // Pagination
  },
  data () {
    return {
      headTitle: "title---rrdh",
      headKeywords: "keywords---rrdh",
      headDesc: "description---rrdh",
      isMounted: false, //for control not ssr render

      friendStatus:-1,
      isLogin: false,
      loginUserId:0,
      total:0,
      showData:[],
      queryParam:{
        columnType:0,
        creatorId:0,
        deleteFlag: 0,
        pageIndex: 1,
        pageSize: 10,
        pageSizes:[10,20,30],
      },
      listLoading:false,
      userInfo:{}
    }
  },
  computed: {
    ...mapState(["userDetail"])
  },
  tdk() {
    return {
      title: this.headTitle,
      description: this.headDesc,
      keywords: this.headKeywords,
      ssrHeadAddInfo: `<link rel="canonical" href="http://www.renrendonghua.com">`
    };
  },
  serverPrefetch() {
    return this.fetchData();
  },
  destroyed() {
    this.$store.commit("SET_USER_DETAIL", { detail: null });
  },
  mounted() {

    this.isMounted = true;

    let userId=this.$route.query.userId

    //console.log("mounted============wenzhang====",this.$route.query.userId)
    //console.log("mounted============wenzhang===this.global=",this.global)

    if(this.global.isLogin){
      this.loginUserId = this.global.userModel.id
      this.isLogin = true
    }
    this.queryParam.creatorId = userId

    const alreadyIncremented = !!this.productionDetail;
    if (!alreadyIncremented) {
      this.fetchData().then(this.initData());
    } else {
      this.initData();
    }



    // let this_ = this
    // let userId=this_.$route.query.userId
    // if(this.global.isLogin){
    //   this_.loginUserId = this.global.userModel.id
    //   this_.isLogin = true
    // }
    // this_.queryParam.creatorId = userId



  },
  methods:{
    fetchData(){
      return this.$store
              .dispatch("FETCH_USER_DETAIL", {
                id: this.$route.query.userId
              })
              .finally(() => {
                this.$loading(false);
                this.setSeo()
                updateTdk.call(this);
              });
    },
    initData(){
      //作者信息
      let thiss = this
      userInfoApi.select(thiss.queryParam.creatorId).then(reUser => {
        thiss.userInfo = reUser.response
      })

      this.search(1)
      this.getFriendStatus()
    },
    setSeo(){
      this.headTitle = this.userDetail.userName+"的文章——人人动画网【官网】";
      this.headKeywords = this.userDetail.impressStr;
      this.headDesc =this.userDetail.userName+"的文章";
    },
    search(page){
      let this_ = this
      this_.queryParam.pageIndex = page
      archiveApi.pageList(this_.queryParam).then(rePro => {
        this_.showData = rePro.list
        this_.total = rePro.total
        this_.queryParam.pageIndex = rePro.pageNum
        this_.toTop()
      })
      this_.toTop()

    },
    doFollow(userId){
      let this_ = this
      homeApi.follower(userId).then(data => {
        // console.log(data)
        const status = data.response.status
        if (status >= 1) {
          this_.userInfo.followStatus=status
          this_.$message.success("关注成功")
        } else {
          this_.$message.error("关注失败")
        }
      })
    },
    undoFollower(userId) {
      let _this = this;
      homeApi.undoFollower(userId).then(data => {
        // console.log(data)
        const status = data.response.status
        if (status == 1) {
          _this.userInfo.followStatus=0
          _this.$message.success("取消成功")
        } else {
          _this.$message.error("取消失败")
        }
      })
    },
    // setHead(){
    //   document.title = this.userInfo.userName+"的文章——人人动画网【官网】"
    //   let head = document.getElementsByTagName('head');
    //   let meta = document.createElement('meta');
    //   document.querySelector('meta[name="description"]').setAttribute('content', this.userInfo.userName+"的文章")
    // },
    toTop () {
      let el = document.getElementById('wenzhang-list');

      let top= el.offsetTop

      window.scrollTo({
        top: top-60,
        behavior: "smooth"
      })
    },

    getFriendStatus(){
      let _this=this;
      let url="/rrbi/friends/getFriendStatus?userId="+_this.queryParam.creatorId+"&currentUserId="+_this.loginUserId+"&ti="+new Date().getMilliseconds();
      _this.$axios.get(url).then(function(result){
        _this.friendStatus = result.data
      })
    },
    addFriend() {
      let _this = this;
      if (_this.global.isLogin) {
        let url = '/rrbi/friends/add/' + _this.queryParam.creatorId + "?ti=" + new Date().getMilliseconds();
        _this.$axios.get(url).then(function (result) {
          console.log(result)
          if (result.data.response.code == 1) {
            _this.$message.success(result.data.response.msg)
            _this.friendStatus = 1
          } else {
            _this.$message.error(result.data.response.msg)
          }
        })
      }
    },
  }
}
</script>

<style scoped lang="less">
.pagintion-f {
  padding: 20px 0 40px;
  text-align: center;
}
.dav-list {
  padding-top: @NAVHEIGHT;
}
//@import "../../../assets/less/stylePublic.less";
</style>
